(function () {
  var slider = document.querySelector('.js-main-slider')
  if(!slider) return false
  slider.insertAdjacentHTML('beforeend','<div class="arrow"></div>')

  var main = slider.querySelector('.js-main-slider-main')
  var thumbnail = slider.querySelector('.js-main-slider-thumbnail')

  function setSwiper(slideContainer) {
    slideContainer.classList.add('swiper-container')
    var slideWrapper = slideContainer.querySelector('.wrapper')
    slideWrapper.classList.add('swiper-wrapper')
    var slide = slideWrapper.querySelectorAll('.slide')
    for (var i = 0; i < slide.length; i++) {
      slide[i].classList.add('swiper-slide')
    }
  }

  setSwiper(main)
  setSwiper(thumbnail)

  var galleryThumbs = new Swiper('.js-main-slider-thumbnail', {
    slidesPerView: 'auto',
    watchOverflow: true,
    spaceBetween: 15,
    centeredSlides: true,
    centeredSlidesBounds: true,
    on: {
      imagesReady: setArrow,
      resize: setArrow
    }
  })

  new Swiper('.js-main-slider-main', {
    speed: 300,
    effect: 'fade',
    allowTouchMove: false,
    thumbs: {
      swiper: galleryThumbs
    }
  })

  function setArrow() {
    var wrapper = thumbnail.querySelector('.swiper-wrapper')
    wrapper.classList.remove('is-right')
    var arrow = slider.querySelector('.arrow')
    if(thumbnail.scrollWidth > thumbnail.clientWidth) {
      arrow.classList.add('is-show')
    } else {
      arrow.classList.remove('is-show')
      wrapper.classList.add('is-right')
    }
  }

}());